import type { ImpactCardData } from "./impactCardData";

export function resolveImpactFundingTotals(data: ImpactCardData) {
  const contributors = data.contributors ?? [];

  const committedFromList = contributors.reduce(
    (sum, item) => sum + item.amount,
    0
  );

  const verifiedFromList = contributors
    .filter((item) => item.status === "Verified")
    .reduce(
      (sum, item) => sum + (item.verifiedAmount ?? item.amount),
      0
    );

  return {
    goalAmount: Math.max(0, data.targetAmount ?? 0),
    committedAmount: Math.max(
      0,
      data.committedFund ?? committedFromList
    ),
    verifiedAmount: Math.max(
      0,
      data.verifiedFund ?? verifiedFromList
    ),
    contributorCount: Math.max(
      0,
      data.contributorCount ?? contributors.length
    ),
  };
}
